"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = exports.initialFilterOptions = exports.initialOrderByOptions = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../../actionTypes/vektorio/linkedFolders");
const types_1 = require("../../../types");
const utils_1 = require("../utils");
const status_1 = require("../../../status");
const statuses = (0, utils_1.createRequestStatus)(status_1.RequestType.FETCH);
exports.initialOrderByOptions = {
    orderBy: 'sokopro',
    order: types_1.ASC
};
exports.initialFilterOptions = {};
exports.initialState = {
    status: statuses.standby(),
    linkedFolders: [],
    orderByOptions: Object.assign({}, exports.initialOrderByOptions),
    filterOptions: Object.assign({}, exports.initialFilterOptions)
};
const statusLens = monocle.Lens.fromProp('status');
const linkedFoldersLens = monocle.Lens.fromProp('linkedFolders');
const orderByOptionsLens = monocle.Lens.fromProp('orderByOptions');
const filterOptionsLens = monocle.Lens.fromProp('filterOptions');
const methods = {};
exports.methods = methods;
methods[ActionTypes.FETCH_LINKED_REQUEST] = (state) => fp.function.flow(statusLens.set(statuses.fetching()), linkedFoldersLens.set([]))(state);
methods[ActionTypes.FETCH_LINKED_SUCCESS] = (state, action) => fp.function.flow(statusLens.set(statuses.success()), linkedFoldersLens.set(action.payload))(state);
methods[ActionTypes.FETCH_LINKED_FAILURE] = (state) => statusLens.set(statuses.failed())(state);
methods[ActionTypes.SET_ORDER_BY_OPTIONS] = (state, action) => orderByOptionsLens.set(action.payload)(state);
methods[ActionTypes.SET_FILTER_OPTIONS] = (state, action) => filterOptionsLens.modify((filters) => {
    const copy = Object.assign({}, filters);
    if (action.payload.value) {
        copy[action.payload.filter] = action.payload.value;
    }
    else {
        delete copy[action.payload.filter];
    }
    return copy;
})(state);
methods[ActionTypes.CLEAR] = () => (Object.assign({}, exports.initialState));
//# sourceMappingURL=index.js.map